export const PUBLICATIONS_CATEGORIES = '/PublicationCategory';
export const PUBLICATIONS = '/Publications';
export const CONTACTS_CATEGORIES = '/ContactCategories';
export const CONTACTS = '/Contacts';
export const SHARE_DOCUMENT = '/ShareDocument';
